import React, { useContext, useEffect, useRef, useState } from "react";
import { Image, Layer, Stage, Text } from "react-konva";
import loadingBack from "../assets/loading-background.png";
import "./Poster.css";
import { AuthContext, serverAddress, appId } from "../App";
import { useParams, useNavigate } from "react-router-dom";
import point from "../assets/gold-hand.png";
import template from "../assets/poster/poster-background.png";
import qrcode from "../assets/poster/qrcode.png";

export default function Poster() {

  const { state } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    if (state.isLogin === false) {
      navigate("/");
    }
  },[state.isLogin])

  const ratio = window.devicePixelRatio;

  const [deviceWidth] = useState(window.innerWidth);
  const stageRef = useRef();
  const output = useRef();
  const [oreoNft, setNft] = useState();
  const [loaded, setLoaded] = useState(false);
  const [loadingDot, setDot] = useState("");
  const [templateLoaded, setTemplateLoaded] = useState(false);
  const [qrcodeLoaded, setQrcodeLoaded] = useState(false);
  const [pressed, setPressed] = useState(false);

  const [client, setOssClient] = useState(null);

  const uiWidth = 375;
  const uiHeight = 812;
  const scale = deviceWidth / uiWidth;

  const imgWidth = 750;

  const [templateImg, setTemplate] = useState();
  const [qrcodeImg, setQrcode] = useState();
  const [owner, setOwner] = useState();
  const [updateTime, setUpdateTime] = useState();
  const params = useParams();

  const getSubStr = (str) => {
    var subStr1 = str.substr(0, 7);
    var subStr2 = str.substr(str.length - 17, 17);
    var subStr = subStr1 + "..." + subStr2;
    return subStr;
  };

  useEffect(() => {
    if (state.isLogin) {
      let headers = new Headers();
      headers.append("appId", appId);
      headers.append("accessToken", state.accessToken);

      fetch(serverAddress + "/ststoken",{
        method: "GET",
        headers: headers,
      }).then((res) => {
        if(res.status === 200){
          res.json().then((res) => {
            if(res.returnCode === "20000"){
              const {accessKeyID,accessKeySecret,securityToken} = res.data;
              const client = new window.OSS.Wrapper({
                region:'oss-cn-shanghai',
                accessKeyId: accessKeyID,
                accessKeySecret,
                stsToken: securityToken,
                bucket: 'bucket-elements'
              })
              setOssClient(client);
            }
          })
        }
      });

      fetch(serverAddress + "/poster/"+ params.id, {
        method: "GET",
        headers: headers,
      }).then((res) => {
        if (res.status === 200) {
          res.json().then((res) => {
            if (res.returnCode === "20000") {
              let tempImg = document.createElement("img");
              tempImg.crossOrigin = "anonymous";
              tempImg.src = template;
              tempImg.onload = () => {
                setTemplateLoaded(true);
              };
              setTemplate(tempImg);
              let qrcodeImg = document.createElement("img");
              qrcodeImg.crossOrigin = "anonymous";
              qrcodeImg.src = qrcode;
              qrcodeImg.onload = () => {
                setQrcodeLoaded(true);
              };
              setQrcode(qrcodeImg);
              let owner = getSubStr(res.data.owner);
              setOwner(owner);
              setUpdateTime(res.data.updateTime);
            } else {
              return null;
            }
          });
        } else {
          return null;
        }
      });
    }
  }, [state.isLogin]);

  useEffect(() => {
    if (templateLoaded && qrcodeLoaded && client !== null) {
      setTimeout(() => {
        const canvas = stageRef.current.toCanvas({pixelRatio: ratio});
        let path = "cbb/poster/" + params.id + '.jpg';
        client.list({prefix:path}).then((res) => {
          if(res.objects && res.objects.length > 0){
            let url = "https://elements.cocafe.co/" + path;
            let result = document.createElement("img");
            result.crossOrigin = "anonymous";
            result.src = url;
            output.current.appendChild(result);
            output.current.scrollTo(0,0);
            result.onload = () => {
              setLoaded(true);
            }
          }
          else {
            canvas.toBlob((blob) => {
              const reader = new FileReader();
              reader.readAsArrayBuffer(blob);
              reader.onload = function (event) {
                const buffer = new window.OSS.Buffer(event.target.result);
                client.put(path, buffer).then(() => {
                  let url = "https://elements.cocafe.co/" + path;
                  let result = document.createElement("img");
                  result.crossOrigin = "anonymous";
                  result.src = url;
                  output.current.appendChild(result);
                  output.current.scrollTo(0,0);
                  result.onload = () => {
                    setLoaded(true);
                  }
                }).catch(function(err){
                  console.log(err);
                });
              }
            },'image/jpeg',1);
          }
        });
      },500);
    }
  }, [qrcodeLoaded, templateLoaded, client]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (loadingDot.length < 3) {
        let newDot = loadingDot + ".";
        setDot(newDot);
      } else if (loadingDot.length === 3) {
        setDot("");
      }
    }, 500);
    return () => {clearTimeout(timer);}
  }, [loadingDot]);

  const handleTap = () => {
    if(loaded) setPressed(true);
  }

  return (
    <div>
      {!pressed &&(
        <div id="poster-enter" style={{ width: deviceWidth, height: window.screen.height, zIndex: 3, backgroundColor: "white" }} onClick={handleTap} onTouchStart={handleTap}>
          <img src={loadingBack} style={{ width: deviceWidth, height: window.screen.height }}/>
          <div id="poster-loading">
            <div className="mt-5 text-sm text-white">
              { loaded ? "轻触屏幕，然后长按图片保存到本地相册" : `努力加载中${loadingDot}` }
            </div>
            {loaded &&
            <div style={{ width: "29px", animation: "blink 1.5s linear infinite", position: 'absolute', top: '170px', zIndex: 3 }} >
              <img src={point}/>
            </div>}
          </div>
        </div>
      )}
      <div style={{ position: "absolute", top: 0, left: 0, zIndex: 1,display: 'flex',alignItems:'center',justifyContent: 'center' }} ref={output}></div>
      {!loaded &&
      <Stage className="absolute left-0 top-0" width={uiWidth * scale} height={uiHeight * scale} ref={stageRef} >
        <Layer>
          <Image image={templateImg} width={uiWidth * scale} height={uiHeight * scale} x={0} y={0} />
          <Image image={qrcodeImg} width={42 * scale} height={42 * scale}  x={297 * scale} y={738 * scale}/>

          <Text text="发行方：" width={120 * scale} x={40 * scale} y={562 * scale} fontSize={10  * scale} fontFamily="'PingFang SC', 'Droid Sans'" fill="#ffffff" align="left" />

          <Text text="创建时间：" width={120 * scale} x={40 * scale} y={598 * scale} fontSize={10  * scale} fontFamily="'PingFang SC', 'Droid Sans'" fill="#ffffff" align="left"/>
          <Text text={updateTime} width={150 * scale} x={180 * scale} y={598 * scale} fontSize={10  * scale} fontFamily="'Helvetica Neue', 'Droid Sans'" fill="#ffffff" align="right"/>
          
          <Text text="创作作者：    咖菲科技" width={120 * scale} x={40 * scale} y={634 * scale} fontSize={10  * scale} fontFamily="'PingFang SC', 'Droid Sans'" fill="#ffffff" align="left" />

          <Text text="所有者地址：" width={120 * scale} x={40 * scale} y={670 * scale} fontSize={10 * scale} fontFamily="'PingFang SC', 'Droid Sans'" fill="#ffffff" align="left" />
          <Text text={owner} width={200 * scale} x={130 * scale} y={670 * scale} fontSize={10 * scale} fontFamily="'Helvetica Neue', 'Droid Sans'" fill="#ffffff" align="right" />
        </Layer>
      </Stage>
      }

    </div>
  );
}
